import { render, staticRenderFns } from "./MisNotificaciones.vue?vue&type=template&id=591129c7&scoped=true&"
import script from "./MisNotificaciones.vue?vue&type=script&lang=js&"
export * from "./MisNotificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591129c7",
  null
  
)

export default component.exports